// Angular
import { Injectable } from '@angular/core';

// Libraries
import { Observable } from 'rxjs';

// Afidium
import { ITemplate } from 'app_sasha/shared/interfaces/ITemplateList';
import { ISmsTemplate, ISmsPreviewRequest, ISmsPreview } from 'app_sasha/shared/interfaces/ISms';
import { ApiResourceService } from 'libraries/service/apiResource/apiResource.service';
import { ISendSmsResponse } from 'libraries/service/resources/model/processing/ISendSmsResponse';
import { ISendSmsRequest } from 'libraries/service/resources/model/processing/ISendSmsRequest';
import { ProcessingResourceService } from '../processings/processingResource.service';
import { ISendSmsParameter } from 'libraries/service/resources/model/processing/ISendSmsParameter';
import { LanguageService } from "libraries/service/language/language.service";

@Injectable()
export class ProcessingSmsResourceService {
    constructor (
        private readonly apiResourceService: ApiResourceService,
        private readonly processingResourceService: ProcessingResourceService,
        private readonly languageService: LanguageService,
    ) {}

    public getSmsTemplates (): Observable<ITemplate[]> {
        return this.apiResourceService.post(
            this.apiResourceService.getApiUrl('dictionary', 'templates', 'search'),
            {
                'template': {
                    'class': 'sms',
                    'category': 'content',
                }
            }
        );
    }

    public getSmsTemplate (smsTemplateId: number): Observable<ISmsTemplate> {
        return this.apiResourceService.getOne(
            this.apiResourceService.getApiUrl('dictionary', 'templates', smsTemplateId)
        );
    }

    public getPreview (syscode: string, formValues: ISmsPreviewRequest): Observable<ISmsPreview> {
        return this.apiResourceService.postOne(
            this.apiResourceService.getApiUrl('booking', 'sms', 'generate'),
            formValues,
            {
                syscode,
                language: this.languageService.userLanguage,
            }
        );
    }

    public sendSms (body: ISendSmsRequest): Observable<ISendSmsResponse> {
        body.parameter.language = this.languageService.userLanguage;
        return this.processingResourceService.create<ISendSmsRequest, ISendSmsResponse, ISendSmsParameter>(body);
    }
}
